import React, { useState } from "react";
import { TextComponent } from "../../../../../components";
import { FaFacebookF, FaFacebookSquare, FaInstagramSquare } from "react-icons/fa";
// import { FaSquareXTwitter } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { Col, Row } from "antd";
import instaIcon from "../../../../../assets/staticImages/instaIcon.png";
import styles from "./aboutUs.module.css";
import { useLocation } from "react-router-dom";
import { FaGoogle, FaSquareXTwitter, FaXTwitter } from "react-icons/fa6";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
import { useDispatch } from "react-redux";
import { ImInstagram } from "react-icons/im";
import { TbWorld } from "react-icons/tb";

const socialAccount = [
  {
    icon: <MdEmail size={25} color="#EF62BD" />,
    link: "Leif Floyd@gmail.com",
  },
  {
    icon: <FaFacebookSquare size={25} color="#62ABEF" />,
    link: "Facebook.com/LeifFloyd",
  },
  {
    icon: <img src={instaIcon} alt="" style={{ width: "25px" }} />,
    link: "instagram.com/LeifFloyd",
  },
];

function AboutUs({ details }) {
  const { state } = useLocation();
  const [isCopied, setIsCopied] = useState(false);
  const dispatch = useDispatch();
  console.log("aboutUs data", details);
  // async function copyTextToClipboard(text) {
  //   if ("clipboard" in navigator) {
  //     return await navigator.clipboard.writeText(text);
  //   }
  // }
  // const handleCopyClick = (link) => {
  //   // Asynchronously call copyTextToClipboard
  //   copyTextToClipboard(link)
  //     .then(() => {
  //       dispatch(showAlert({
  //         type: "Success",
  //         message: "Copied"
  //       }))
  //       // If successful, update the isCopied state value
  //       setIsCopied(true);
  //       // setIsCopyModalOpen(false)
  //       setTimeout(() => {
  //         setIsCopied(false);
  //       }, 1500);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Row className={styles.aboutCont}>
          <TextComponent text={"About"} />
        </Row>
        <TextComponent
          textClass={styles.aboutText}
          text={
            details?.business_info?.description
              ? details?.business_info?.description
              : details?.about_the_vendor
              ? details?.about_the_vendor
              : "--"
          }
        />
      </div>
      {details?.service_category_name != "company" && (
        <Row className={styles.linkCont}>
          {details?.sociallink?.map((data) => (
            // <Row
            //   style={{ alignItems: "center", justifyContent: "space-around" }}
            //   className={styles.socialIcons}
            //   onClick={()=>handleCopyClick(data?.link)}
            // >
            <a
            href={data?.link}
            target="blank"
            className={styles.socialIcons}
              style={{ alignItems: "center", justifyContent: "space-around" }}

          >
               {data?.platform?.includes("google") ? <FaGoogle /> :
                data?.platform?.includes("facebook") ? <FaFacebookF /> : 
                data?.platform?.includes("instagram") ?  <ImInstagram/> :
                data?.platform?.includes("twitter") ?  <FaXTwitter /> : <TbWorld />
                }
              {/* <TextComponent textClass={styles.linkText}>
                <a
                  href={data?.link}
                  target="blank"
                  style={{ color: "inherit" }}
                >
                  {data?.link}
                </a>
              </TextComponent> */}
            {/* </Row> */}
            </a>

          ))}
        </Row>
      )}
    </>
  );
}

export default AboutUs;
